import styled from 'styled-components';

import { CONTAINER_MAX } from '@/constants/breakpoints';
import { Z_INDEX } from '@/constants/z-index';
import { flexCenterAligned, flexColumn, scrollHidden } from '@/styles/common';

export const ModalOverlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  min-height: 100vh;
  ${flexCenterAligned};
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
  z-index: ${Z_INDEX.OVERLAY};

  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: opacity 300ms ease;

  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    align-items: flex-end;
  }
`;

export const ModalContainer = styled.div<{
  $isExtraContentVisible: boolean;
  $isOpen: boolean;
  $isPublication: boolean;
}>`
  width: 100%;
  position: fixed;

  max-width: ${({ $isPublication }) => ($isPublication ? '800px' : '600px')};

  max-height: ${({ $isExtraContentVisible }) =>
    $isExtraContentVisible ? '720px' : '640px'};

  border-radius: 28px;
  background: ${({ $isPublication }) =>
    $isPublication ? 'var(--bg-main)' : 'var(--bg-card)'};
  ${flexColumn};
  overflow: auto;
  transform: translateX(-50%) translateY(-50%);
  left: 50%;
  top: 50%;
  z-index: ${Z_INDEX.MODAL};

  &::-webkit-scrollbar {
    ${scrollHidden}
  }

  scrollbar-width: none;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0;
    top: 0;
    gap: 10px;
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 0;
    transform: none;
    z-index: ${Z_INDEX.MODAL};
  }
`;
